import { type } from "./actionTypes"

const initialState = {
  saveHealthAndSafety: {},
}

const HealthAndSafety = (state = initialState, action) => {
  switch (action.type) {
    case type.SAVE_HEALTH_AND_SAFETY_REPORT:
      console.log("action.data", action.payload.value)
      let facId = action.payload.value.facId
      let date = action.payload.value.date

      return {
        ...state,
        saveHealthAndSafety: {
          ...state.saveHealthAndSafety,
          [facId]: {
            ...state.saveHealthAndSafety[facId],
            [date]: action.payload.value,
          },
        },
      }
    case type.REMOVE_HEALTH_AND_SAFETY_REPORT: {
      const { facId: rFacId, date: rDate } = action.payload.value
      const existing = state.saveHealthAndSafety[rFacId]
      if (!existing) return state
      const { [rDate]: _removed, ...restForFac } = existing
      return {
        ...state,
        saveHealthAndSafety: {
          ...state.saveHealthAndSafety,
          [rFacId]: restForFac,
        },
      }
    }
    default:
      return state
  }
}

export default HealthAndSafety
